/* istanbul ignore file */

import { find, get, sortBy } from 'lodash';
import { connect } from 'react-redux';

import MobileSizeSelector from 'components/CustomCollectionProductCard/MobileSizeSelector';
import { COLLECTION_ITEM_TYPES } from 'constants/collection';
import * as actions from 'state/actions';
import { ADD_TO_CART_ANALYTICS_ORIGINS } from 'state/constants';
import Catalog from 'state/selectors/catalog';
import { getMasterProductData } from 'state/selectors/collection';
import CollectionPage from 'state/selectors/collection-page';
import Filters from 'utils/Filters';

const mapStateToProps = (state, ownProps) => {
  const { masterHandle, initialColorwayHandle } = ownProps;
  let renamedMasterHandle = masterHandle;
  if (ownProps.productType === COLLECTION_ITEM_TYPES.COLORWAY) {
    const sufix = initialColorwayHandle || COLLECTION_ITEM_TYPES.COLORWAY;
    renamedMasterHandle = `${masterHandle}-${sufix}`;
  }

  const masterProduct = getMasterProductData(state, renamedMasterHandle);
  const currentColorwayHandle = get(masterProduct, ['currentProduct']);
  const availableColorways = Catalog.getAvailableMasterProductColorways(state, masterHandle);
  const masterProductCacheKey = Catalog.getMasterProductCacheKey(state, masterHandle);
  const cacheKey = CollectionPage.getCollectionFilterCacheKey(state, masterProductCacheKey);

  const filteredColorways = Filters.executeFilters({
    items: availableColorways,
    filterItems: CollectionPage.getFilteringEngineFilterItems(state),
    cacheKey,
  });
  // Move initialColorwayHandle to the front, if it exists
  let filteredSortedColorways = filteredColorways;
  if (initialColorwayHandle) {
    filteredSortedColorways = sortBy(filteredColorways, ({ handle }) =>
      handle === initialColorwayHandle ? 0 : 1
    );
  }
  // See if the selected product is in the filtered list. If no, fallback on first product in master product collection
  let currentColorway = find(filteredSortedColorways, { handle: currentColorwayHandle });
  if (!currentColorway) {
    currentColorway = get(filteredSortedColorways, [0]);
  }
  return {
    ...ownProps,
    masterHandle: renamedMasterHandle,
    sortedSizes: currentColorway.sortedSizes,
    type: currentColorway.type,
  };
};

const mapDispatchToProps = dispatch => ({
  onSizeSelection: (variantId, targetSelector) => {
    dispatch(
      actions.addLineItems(
        { [variantId]: 1 },
        { targetSelector, origination: ADD_TO_CART_ANALYTICS_ORIGINS.QUICK_ADD }
      )
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileSizeSelector);
